export default {
  "Sivut": "Pages",
  "Ei luokiteltu": "Uncategorized",
  "Viimeiset 8 viikkoa": "Last 8 weeks",
  "Vie palautteet": "Export feedback",
  "Ulkoasuasetukset": "Theme settings",
  "Logo": "Logo",
  "Väri": "Color",
  "Logon tulee olla PNG-tiedosto, jonka tausta on läpinäkyvä.": "The logo must be a PNG file with a transparent background.",
  "Ei logoa": "No logo",
  "Valitse logo": "Choose logo",
  "Logon tulee olla PNG-tiedosto.": "The logo must be a PNG file.",
  "Tiedosto on liian suuri (max 5 MB).": "The file is too large (max 5 MB).",
  "Logon tausta tulee olla läpinäkyvä.": "The logo background must be transparent.",
  "Tiedostoa ei voitu lukea kuvana.": "The file could not be read as an image.",
  "Logon tallennus epäonnistui.": "Saving the logo failed.",
  "Poista logo": "Remove logo",
  "Logon poistaminen epäonnistui.": "Removing the logo failed.",
  "Näytön logo korvaa yrityksen logon tällä näytöllä. Kuvan ei tarvitse olla neliö.": "The screen logo replaces the company logo on this screen. The image does not need to be square.",
  "Tehosteväriä käytetään sovelluksen painikkeissa, otsikoissa ja korostuksissa.": "The accent color is used for the app's buttons, headings and highlights.",
  "Esikatselu": "Preview",
  "Esimerkki": "Example",
  "Painike": "Button",
  "Värin tallennus epäonnistui.": "Saving the color failed.",
  "Pääkäyttäjät": "Main users",
  "Vain pääkäyttäjät voivat lisätä tai poistaa toisia pääkäyttäjiä.": "Only main users can add or remove other main users.",
  "Näytä loki": "Show log",
  "Lisää pääkäyttäjä": "Add main user",
  "Ei pääkäyttäjiä": "No main users",
  "Et voi poistaa itseäsi pääkäyttäjistä": "You cannot remove yourself from main users",
  "Viimeistä pääkäyttäjää ei voi poistaa": "The last main user cannot be removed",
  "Poista pääkäyttäjistä": "Remove from main users",
  confirm_remove_mainuser: "Are you sure you want to remove user {name} from main users? The user will remain in the system as a regular user.",
  "Hae käyttäjää": "Search user",
  "Kirjoita nimi tai sähköposti": "Type a name or email",
  "Ei tuloksia": "No results",
  "Lisää pääkäyttäjäksi": "Add as main user",
  "Pääkäyttäjän lisääminen epäonnistui": "Adding main user failed",
  "Pääkäyttäjien muutosloki": "Main users change log",
  "Ei merkintöjä": "No entries",
  "Toiminto": "Action",
  "Suoritti": "Performed by",
  "Pääkäyttäjän oikeudet lisätty": "Main user permissions granted",
  "Pääkäyttäjän oikeudet poistettu": "Main user permissions removed",

  "feedback_newview_info": "We are renewing feedback management! Try the new view below. The new interface will become the default in the future.",
  "Uusi näkymä": "New view",
  "Ohjeet": "Guide",
  "Puhelinnumero": "Phone number",
  "Pitkä vastaus": "Long answer",
  "Lyhyt vastaus": "Short answer",
  "Valitse yksi": "Select one",
  "Takaisin": "Back",
  "Saapuneet / luokka": "Inbox / category",
  "Vanha näkymä": "Old view",
  "Päivitä": "Refresh",
  "Näytä valmiit": "Show completed",
  "Tieto ei näy palautteen lähettäjälle": "Not visible to the feedback sender",
  "Sisäinen otsikko": "Internal title",
  "Ei valmiita palautteita": "No completed feedback",
  "Ei saapuneita palautteita": "No incoming feedback",
  "Ei käsittelyssä olevia palautteita": "No feedback in progress",
  "Näytä infotv näytöillä": "Show on Infotv screens",
  "Lomake": "Form",
  "Ei käytössä": "Not in use",
  "Käytä mukautettua lomaketta": "Use custom form",
  "Poista palautetyyppi käytöstä ja tallenna muutokset muokataksesi lomakekenttiä": "Disable the feedback type and save changes to edit form fields",
  "Sisältö": "Content",
  "Asetukset": "Settings",
  "Lataa ja lisää": "Upload and add",
  "Näyttö": "Display",
  "Toissijainen sisältö (30%)": "Secondary content (30%)",
  "Pääsisältö (70%)": "Main content (70%)",
  "Alatunnisteen tekstit": "Footer texts",
  "Lisää teksti": "Add text",
  "Näytöt": "Displays",
  "Ulkoasu": "Appearance",
  "Sää": "Weather",
  "Näytön sisällönhallinta": "Display Content Management",
  "Asettelu": "Layout",
  "Haluatko varmasti poistaa sisällön näytöltä?": "Are you sure you want to remove the content from the display?",
  "Jaettu asettelu (70% / 30%)": "Split layout (70% / 30%)",
  "Koko leveys": "Full width",
  "Tumma tila": "Dark mode",
  "Näytä alatunniste": "Show footer",
  "Sisällön näyttöaika (sekuntia)": "Content display time (seconds)",
  "Valitse kirjastosta": "Select from library",
  "Ei hakutuloksia": "No search results",
  "Ei kuvia kirjastossa": "No images in the library",
  "Lisää näytölle": "Add to display",
  "Virhe lisättäessä sisältöä": "Error adding content",
  "kohdetta": "items",
  "Lisää": "Add",
  "Lataa kuva": "Upload image",
  "Kirjastosta": "From library",
  "Uutiset": "News",
  "Tapahtumat": "Events",
  "Lisää sisältöä yllä olevilla painikkeilla": "Add content using the buttons above",
  "aktiivista uutista.": "active news.",
  "Näytetään max 5 uusinta uutista": "Showing max 5 latest news",
  "Ei aktiivisia uutisia": "No active news",
  "Ilmoittautuneet": "Registered",
  "permanent_pages_info": "Permanent pages appear in the Piiri app menu as their own sections (for example, with the title Our company). You can create new sections if you want to group permanent page content into separate topics that appear in the menu. A new section will appear in the menu when the app is restarted or the browser page is refreshed",
  "Osio": "Section",
  "Luo uusi osio": "Create new section",
  "Pysyvät sivut": "Permanent pages",
  "Uusi kyselytyökalu": "New survey tool",
  "Lomakkeella on vastauksia. Muokkaus rajoitettu.": "The form has responses. Editing is limited.",
  "Huom: Lomaketta voi muokata rajoitetusti sen jälkeen kun siihen on tullut vastauksia.": "Note: The form can be edited in a limited way after it has received responses.",
  "surveyinfo1": "We are renewing surveys. You can try the new survey tool",
  "surveyinfo2": "The Piiri mobile app needs to be updated to the new version (1.15.0) for surveys created with the new survey tool to be visible to users.",
  "Sinulla ei ole oikeuksia kaikkiin tämän julkaisun ryhmiin.": "You do not have permissions to all groups of this publication.",
  "Voit tarkastella julkaisua, mutta et voi tehdä muutoksia.": "You can view the publication, but you cannot make changes.",
  "Oletus": "Default",
  "Vie kaaviot kuvana": "Export charts as image",
  "Suodattimet": "Filters",
  "Tyhjennä": "Clear",
  "Aikavyöhyke": "Timezone",
  "Vastausvaihtoehto": "Answer option",
  "Lisää vaihtoehto": "Add option",
  "Tyhjä vaihtoehto": "Empty option",
  "Vaihtoehto": "Option",
  "Vastausvaihtoehdot": "Answer options",
  "Haluatko varmasti poistaa vastausvaihtoehdon?": "Are you sure you want to delete the answer option?",
  "vastausta": "answers",
  "Ei vastauksia": "No answers",
  "Kentällä ei ole otsikkoa": "Field has no title",
  "Klikkaa muokataksesi kenttää": "Click to edit field",
  "Ohjeteksti (valinnainen)": "Help text (optional)",
  "Päivämäärä": "Date",
  "Pakollinen": "Required",
  "Kentän otsikko": "Field title",
  "Tietotyyppi": "Data type",
  "Vastausaika on pakollinen": "Response time is required",
  "Monirivinen teksti": "Multiline text",
  "Ei kysymyksiä. Lisää ensimmäinen kysymys vasemmalta.": "No questions. Add the first question from the left.",
  "Monivalinta": "Multiple choice",
  "Valinta": "Choice",
  "Valitse vähintään yksi ryhmä": "Select at least one group",
  "Teksti": "Text",
  "Lisää kysymys": "Add question",
  "Lomakkeen kentät": "Form fields",
  "Julkaise ryhmiin": "Publish to groups",
  "Kopioi kysely": "Copy poll",

  "Tietoa Piiri-sovelluksesta": "About the Piiri app",
  "Vaadi lukukuittaus": "Require read acknowledgment",
  "Selite (valinnainen)": "Description (optional)",
  "Teksti näytetään käyttäjille lukukuittauksen yhteydessä": "The text is shown to users when confirming read acknowledgment",
  "Jos nostatte versionumeroa, käyttäjiltä vaaditaan sisällölle uudelleen lukukuittaus": "If you increase the version number, users will be required to acknowledge the content again",
  "Sivu": "Page",
  "Lukukuittaus saatu": "Read acknowledgment received",
  "Ei lukukuittausta": "No read acknowledgment",
  "Lukukuittauksia ei ole käytössä": "Read acknowledgments are not enabled",
  "Versio": "Version",
  "Raportti": "Report",
  "Ryhmän ylläpitäjä näkee vain ylläpitämiensä ryhmien tiedostot": "The group administrator can only see the files of the groups they manage",
  "Muokkaa kansiota": "Edit mapp",
  "Uusi kansio": "New folder",
  "Uusi alikansio": "New subfolder",
  "tiedostoa": "files",
  "Muokkaa": "Edit",
  "Lukukuittaukset": "Read acknowledgments",
  "Failed to submit acknowledgment. Please try again.": "Failed to submit acknowledgment. Please try again.",
  "Kuittaa luetuksi": "Acknowledge as read",
  "Lukukuittaus": "Read acknowledgment",
  "Lukukuittaus vaaditaan": "Read acknowledgment required",
  "Olet kuitannut tämän luetuksi": "You have acknowledged this as read",
  "Sisältö on päivittynyt viime kuittauksesi jälkeen. Kuittaa uudelleen.": "The content has been updated since your last acknowledgment. Please acknowledge again.",
  "Tämä sisältö vaatii lukukuittauksen.": "This content requires read acknowledgment.",
  "Your browser does not support the video tag.": "Your browser does not support the video tag.",
  "Avaa linkki": "Open link",
  "Kaikki tiedostot": "All files",
  "Kansio": "Folder",
  "Avaa tiedosto": "Open file",
  "Kansion nimi": "Folder name",
  "Järjestys": "Order",
  "Haluatko varmasti poistaa kansion?": "Are you sure you want to delete the folder?",
  "Anna kansion nimi": "Enter folder name",
  "Vie ilmoittautumiset": "Export enrollments",
  "Avainsanoilla voidaan luokitella ja suodattaa uutisia.": "News can be classified and filtered using keywords.",
  "Ryhmä on käytössä": "The group is active",
  "Ryhmä ei ole käytössä": "The group is not active",
  "DisableGroupInfo": "A group can be marked as inactive if it has none of the following:\n- administrator\n- discussion channel\n- Our Company page (or another named permanent page)\n\nHow to mark a previously active group as inactive:\n- Remove the group’s administrative rights in user management.\n- Mark the discussion channels linked to the group as inactive.\n- Delete the Our Company pages created for the group or transfer them to another group. If the permanent page is visible to multiple groups, it is enough to remove its visibility from the group being removed.\n\nNote!\nOther content created for the group (news, events, surveys, files) will remain in Piiri even when the group is deleted.",
  "Käyttäjä halitsee tietoa itse": "The user controls the information themselves",
  "Käyttäjän kielivalinta": "User’s language selection",
  "Tiedoston maksimikoko on 10MB": "The maximum file size is 10MB",
  "Peruuta": "Cancel",
  "Avainsanat käytössä": "Enable keywords",
  "Uusi ryhmä": "New group",
  "Hae": "Search",
  "Järjestä": "Sort",
  "department-info": "The use of departments is voluntary. Grouping of users into departments is visible only in the 'Employees' section. If the company groups staff into departments, users can search for contact information by department.",
  "Oletusuutiskuva": "Default news image",
  "Julkaisuasetukset": "Publication settings",
  "Oletusuutiskuvaa käytetään logon sijaan uutisissa mikäli uutisella ei ole omaa kuvaa.": "The default image is used instead of the logo in news items if the news item does not have its own image.",
  "Hae otsikolla": "Search by title",
  "Kysymys julkaistaan heti": "The question will be published immediately",
  "Tapahtuma julkaistaan julkaisuaikana": "The event will be published at the scheduled time",
  "Nimi on pakollinen kaikilla kielillä": "Name is required in all languages",
  "Uusi osasto": "New department",
  "Kaikki": "All",
  "Osastot": "Departments",
  "Ryhmät": "Groups",
  "Ryhmän nimi": "Group name",
  "Oma tila": "My status",
  "Yhteiset liitteet": "Common attachments",
  "attachment_lang_tip": "Common attachments are visible to everyone, regardless of language choice. Language version attachments are only visible to users of that language choice.",
  "Käännös suoritettu. Varmista käännöksen oikeellisuus ennen tallentamista.": "Translation completed. Please check the accuracy of the translation before saving.",
  "Suorita käännös": "Perform translation",
  "Automaattinen käännös": "Automatic translation",
  "deepl_notice": "The <a href='https://www.deepl.com/en/translator' target='_blank'> DeepL service</a> will be used to translate the content. Please note that the translated text will be sent to DeepLi's servers for processing. The company is responsible for ensuring the accuracy and suitability of the translated content. The tool is intended only for translating Piiri's content",
  "Haluatko varmasti poistaa käyttäjän? Toimintoa ei voi perua!": "Are you sure you want to delete the user? The action cannot be cancelled!",
  "Jos haluat päivittää kuvan, poista ensin olemassa oleva kuva": "If you want to update the image, first remove the existing image.",
  "ryhmää": "groups",
  "Push-ilmoitukset käytössä": "Send push-notifications",
  "Kansikuvat": "Cover images",
  "Ei kuvia, näytetään logo": "No images, showing logo",
  "Lisää uusi kansikuva": "Add a new cover image",
  "Enintään 5 kuvaa voidaan lisätä": "A maximum of 5 images can be added",
  "Haluatko varmasti poistaa kuvan?": "Are you sure you want to delete the image?",
  "Kuvien suositeltu kuvasuhde on 16:9, esim. 1920x1080px": "The recommended aspect ratio for images is 16:9, e.g., 1920x1080px",
  "Kuvat näytetään kuvakarusellissa": "Images are displayed in an image carousel",
  "Vastauksiin liitetään nimi automaattisesti": "The name will be automatically attached to the responses",
  "Kyselyyn voi vastata useita kertoja": "You can answer the survey multiple times",
  "Vastaukset kerätään anonyymisti": "The responses are collected anonymously",
  "Tätä asetusta ei voi muuttaa sen jälkeen kun kyselyyn on vastattu": "This setting cannot be changed after the survey has been answered",
  "Salli useita vastauksia samalta käyttäjältä": "Allow multiple responses from the same user",
  "Palautteiden käsittelijäksi voidaan...": "Note: The feedback permissions can be selected for main users or group administrators. You can add the group administrator rights under the Users section.",
  "Kaikki muutokset kirjataan lokiin": "All changes made to the feedback permissions are logged. (View the log by clicking on the icon to the right.)",
  "Valitse käsittelyoikeudet": "Select permissions",
  "Käsittelyoikeudet": "Permissions",
  "Tallennus onnistui": "Save successful",
  "Aikaleima": "Timestamp",
  "Suorittanut": "Performed by",
  "Kohdekäyttäjä": "Target user",
  "Tapahtuma": "",
  "Loki": "Log",
  "CategoryInfo": 'Feedback classification has not been enabled. Create custom categories for different feedback types by selecting "New feedback type" and writing instructions for the feedback type',
  "Palautetyypit": "Response types",
  "Palautetyypin nimi": "Name of feedback type",
  "Valitse palautteen tyyppi": "Select type of feedback",
  "Otsikko on pakollinen kaikilla kielillä": "Title is required in all languages",
  "Ohje palautteen lähettäjälle (esim. mitä tietoja ilmoitukseen tulee lisätä)": "Instructions for the feedback sender (e.g., what information should be included in the report)",
  "Lyhyt kuvaus (milloin palautetyyppiä käytetään)": "Brief description (when should the feedback type be used)",
  "Uusi luokittelu": "New feedback type",
  "Palautteiden luokittelu": "Feedback classification",
  "Haluatko varmasti ottaa palautteen käsittelyyn?": "Are you sure you want to process the feedback?",
  "Käyttäjä on jättänyt yhteystiedot yhteydenottoa varten": "The user has left contact information for contact purposes",
  "Palaute on käsitelty": "The feedback has been processed",
  "Palauteilmoitukset": "Feedback admin",
  "Kirjoita viesti": "Write message",
  "Sinä": "You",
  "Voit lähettää yhden viestin vastauksena": "You can send one message as a response",
  "Haluatko varmasti lähettää viestin?": "Are you sure you want to send the message?",
  "Palautteet": "Feedback archive",
  "Näytä lähetetyt palautteet": "Show sent feedbacks",
  "Piilota lähetetyt palautteet": "Hide sent feedbacks",
  "Haluatko jättää yhteystietosi henkilökohtaista vastausta varten?": "Do you want to leave your contact information for a personal response?",
  "Käsitelty": "Completed",
  "Avoin": "Open",
  "Voit lähettää palautteen lähettäjälle viestin tai vastauksen sen jälkeen, kun palaute on otettu käsittelyyn": "You can send a message or reply to the sender of the feedback after the feedback has been taken into handling",
  "Tietoja": "About",
  "Palautteen lähettäjä voi vastata lähettämääsi viestiin tai viesteihin niin kauan, kunnes palaute on merkitty käsitellyksi.": "The sender of the feedback can reply to your message or messages as long as the feedback has not been marked as completed.",
  "Käyttäjä": "User",
  "Yhteystiedot": "Contact information",
  "Viestit": "Messages",
  "Käyttäjä ei ole jättänyt yhteystietoja": "The user has not provided contact information",
  "Lähetä lisäkysymys tai vastus": "Send a question or reply",
  "Vie vastaukset": "Export replies",
  "Päivitykset": "Updates",
  "Kutsu uudet käyttäjät": "Invite new users",
  "Lisää uusi palautteiden käsittelijä": "Add new feedback manager",
  "Ilmoitus sähköpostiin": "Email notification",
  "Push-viesti puhelimeen": "Push-notification",
  "Kutsu käyttäjiä": "Invite users",
  "Käytä viestipohjaa": "Use message template",
  "Kutsuohje": "The message below will be sent via text message to selected users. If you wish, you can edit the message before sending it.\
  If you wish, you can edit the message before sending it.",
  "Varmista, että käyttäjien puhelinnumerot ovat oikein ennen viestin lähetystä.": "Ensure that the users' phone numbers are correct before sending the message.",
  "Kutsumattomia käyttäjiä ei löytynyt": "Kutsumattomia käyttäjiä ei löytynyt",
  "Kutsu valitut käyttäjät": "Kutsu valitut käyttäjät",
  "Lähetys käynnissä, odota...": "Lähetys käynnissä, odota...",
  "Lähetys on valmis": "Lähetys on valmis",
  "Kutsu käyttäjälle": "Kutsu käyttäjälle",
  "numeroon": "numeroon",
  "epäonnistui": "epäonnistui",
  "Päivitä lista": "Päivitä lista",
  "Viesti on pakollinen": "Viesti on pakollinen",
  "Kirjoita vastaus": "Write your answer",
  "Vastauksia": "Answers",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomutooja ovat ": "File type is not supported. Supported file types are ",
  "Liitetiedosto": "Attachment",
  "Halutessasi voi liittää liitetiedoston": "You can add an attachment if necessary",
  "Halutessasi voit liittää mukaan kuvan tai pdf-tiedoston": "You can attach an image or pdf file if nesessary",
  "Liite": "Attachment",
  "Ladataan...": "Downloading...",
  "Vastausaika on päättynyt": "Reply time has expired",
  "Ei ilmoittautumisia": "No enrollments",
  "Voit lähettää viestin Ctrl Enter painikkeilla": "You can send the message by pressing Ctrl + Enter",
  "Omat keskustelut": "My discussions",
  "Näytä keskustelukanavat": "Show channels",
  "Yksityinen kanava": "Private channel",
  "Hallinnoit tätä kanavaa": "You are managing this channel",
  "Aloita uusi keskustelu": "Start new discussion",
  "Miten palautteet käsitellään": "How is feedback handled",
  "Haku": "Find",
  "Omat tiedot ja asetukset": "My information and settings",
  "Julkaisuaika on pakollinen": "Publish date is required",
  "Kuvaus...": "Description...",
  "Saapunut ...": "Arrived ...",
  "päivää sitten": "days ago",
  "Nimi puuttuu": "Name is missing",
  "Haluatko varmasti poistaa tapahtuman?": "Are you sure you want to remove the event?",
  "Ylläpito": "Administration",
  "Etusivu": "Home",
  "Hallinta": "Administration",
  "Muut": "More",
  "Omat tiedot": "My information",
  "Kirjaudu ulos": "Log out",
  "Lähetä": "Send",
  "Olet vastannut kyselyyn": "You have answered the poll",
  "Kyselyt": "Polls",
  "Vastausaika päättyy": "Answer time expires",
  "Ei kyselyjä": "No polls",
  "Uusi tiedosto lisätty": "New file added",
  "Yritys": "Company",
  "Raahaa kuva tähän tai klikkaa tästä ja valitse kuva tiedostoista.": "Drag a picture here or choose one from your files.",
  "Kuponki": "Coupon",
  "Otsikko": "Title",
  "Kuvaus": "Description",
  "Etu julkaistaan heti": "The benefit will be published immediately",
  "Etu tallennetaan luonnoksena": "Save benefit as draft",
  "Julkaise": "Publish",
  "Tarkista lomakkeen tiedot": "Check the form details",
  "Poista": "Delete",
  "Tallenna": "Save",
  "Tallenna lisätieto": "Save comment",
  "Henkilöstöedut": "Benefits",
  "Uusi etu": "New benefit",
  "Julkaistu": "Published",
  "Keskustelukanavat": "Chat channels",
  "Nimi": "Name",
  "Kuva": "Image",
  "Kanavan tyyppi": "Channel type",
  "Yksityinen keskustelu": "Private chat",
  "Ryhmäkeskustelu": "Group chat",
  "Kanavaa hallinnoivat": "Managers of the channel",
  "Käytössä": "Active",
  "Kanava on käytössä": "Channel is active",
  "Kanava ei ole käytössä": "Channel is inactive",
  "Uusi kanava": "New channel",
  "Aktiivinen": "Active",
  "Klo": "At",
  "klo": "at",
  "Ilmoittautuminen päättyy": "Enrollment closes",
  "Ilmoittautumiset": "Enrollments",
  "Henkilö": "Person",
  "Ilmoitautumisaika": "Enrollment time",
  "Kommentti": "Comment",
  "Tapahtumat": "Events",
  "Julkaise ryhmään": "Publish to group",
  "Tapahtuman alkuaika": "Event start time",
  "Tapahtuman päättymisaika": "Even end time",
  "Ilmoittautuminen": "Enrollment",
  "Kommentti ilmoittautumisen yhteydessä": "Comment at enrollment",
  "Tapahtuma julkaistaan heti": "Event will be published immediately",
  "Tapahtuma tallennetaan luonnoksena": "Event will be saved as draft",
  "Ryhmä on pakollinen": "Group is required",
  "Otsikko ja teksti on pakollinen": "Title and text is required",
  "Alkuaika on pakollinen": "Start time is required",
  "Tarkista päättymisaika": "Check end time",
  "Tarkista ilmoittautumisen päättymisaika": "Check enrollment end time",
  "Otsikko tai teksti puuttuu": "Title or text is missing",
  "Uusi tapahtuma": "New event",
  "Aika": "Time",
  "Ryhmä": "Group",
  "Kysymykset & vastaukset": "Frequently asked questions",
  "Kysymys": "Question",
  "Uusi kysymys": "New question",
  "Saapunut": "Arrived",
  "Käsittelyssä": "In progress",
  "Otettu käsittelyyn": "In progress",
  "Valmis": "Complete",
  "Palaute": "Feedback",
  "Käyttäjä toivoo vastausta": "User expects answer",
  "Käyttäjä ei toivo vastausta": "User does not expect answer",
  "Käsittely": "In progress",
  "Ota käsittelyyn": "Handle",
  "Sisäinen lisätieto": "Internal comment",
  "Sisäinen lisätieto ei näy palautteen lähettäjälle": "Internal comment is not visible to the sender",
  "Kuittaa käsitellyksi": "Mark as complete",
  "Palautekanava": "Feedback",
  "SUODATA": "FILTER",
  "Saapuneet": "New",
  "Käsittely kesken": "In progress",
  "Valmiit": "Completed",
  "Saapunut tänään": "Arrived today",
  "Lisää kuva klikkaamalla tai raahaamalla kuva tähän": "Drag a picture here or choose one from your files.",
  "Julkaisuaika": "Publish time",
  "Liitteet": "Attachments",
  "Lisää uusi liitetiedosto": "Add new attachment",
  "Voit lisätä sivulle liitteitä tallennuksen jälkeen": "You can add attachments after the page has been saved",
  "Video": "Video",
  "Lisää uutiseen video": "Add video",
  "Kysely": "Poll",
  "Lisää julkaisuun kysymys": "Add a poll",
  "Kyselyyn on vastattu eikä kysymyksiä voi enää muokata": "The poll has been answered and annot be edited",
  "Kysymykset": "Questions",
  "Uusi monivalintakysymys": "New multiple choice question",
  "Uusi avoin kysymys": "New open question",
  "Kirjoita kysymys": "Write question",
  "Lisää vastausvaihtoehto": "Add answer option",
  "Kirjoita vastausvaihtoehto": "Write answer option",
  "Uutinen julkaistaan julkaisaikana": "News will be published immediately",
  "Uutinen tallennetaan luonnoksena": "News will be saved as draft",
  "Uutiset": "News",
  "Uusi uutinen": "New news",
  "Näytä vastaukset": "Show answers",
  "Julkaisupäivä": "Publish time",
  "Meidän yritys": "Our company",
  "Valitse kuva": "Choose image",
  "Keskustelut": "Discussion",
  "Lisää sivulle video": "Add video",
  "Vimeo videon id": "Vimeo video id",
  "Sivu julkaistaan heti": "The page will be published immediately",
  "Sivu tallennetaan luonnoksena": "The page will be saved as a draft",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomuotoja ovat jpeg sekä png.": "File format is not supported. Supported formats are jpeg och png.",
  "Uusi sivu": "New page",
  "Lisää alasivu": "Add subpage",
  "Yhteenveto": "Summary",
  "Vastaukset": "Answer",
  "Vastausaika": "Answertimed",
  "Vastauksia": "Answers",
  "Otsikko ja kuvaus on pakollinen": "Title and description is required",
  "Päivämäärä on pakollinen": "Date is required",
  "Kyselyssä ei ole yhtään kysymystä": "The poll has no questions",
  "Tarkista kysymykset": "Check questions",
  "Otsikko tai kuvaus puuttuu": "Title or description is missing",
  "Haluatko varmasti poistaaa kyselyn ja kaikki sen vastaukset?": "Are you sure you want to remove the poll and its answers?",
  "Uusi kysely": "New poll",
  "Tiedosto": "File",
  "Linkki": "Link",
  "Valitse uusi tiedosto": "Choose new file",
  "Tämä tieto on pakollinen": "The field is required",
  "Max 500 merkkiä": "Max 500 characters",
  "Tiedosto julkaistaan heti": "The file will be published immediately",
  "Tiedosto tallennetaan luonnoksena": "The file will be saved as a draft",
  "Tiedosto puuttuu": "File is missing",
  "Linkki puuttuu": "Länken fattas",
  "Tiedostot": "Documents",
  "Uusi tiedosto": "New file",
  "Avaa": "Open",
  "Tyyppi": "Type",
  "Miten palautteet käsitellään?": "How do we handle feedback?",
  "Palauteasetukset": "Feedback settings",
  "Palautteiden käsittelykäytäntö": "Feedback policy",
  "Käyttäjät": "Users",
  "Etunimi": "First name",
  "Sukunimi": "Last name",
  "Puhelin": "Phone",
  "Sähköposti": "Email",
  "Työtehtävä": "Title",
  "Näytä sähköposti kaikille": "Show email to everyone",
  "Näytä puhelinnumero kaikille": "Show phone to everyone",
  "Käyttäjä on yrityksen pääkäyttäjä, jolla on oikeudet julkaista kaikkiin ryhmiin": "The user is a main user and has permission to publish to all groups",
  "Ryhmän ylläpitäjä": "Group administrator",
  "Suodata": "Filter",
  "Uusi käyttäjä": "New user",
  "Näytä ryhmän ylläpitäjät": "Show group administrators",
  "Sähköposti": "Email",
  "Kaikki käyttäjät": "All users",
  "Yrityksen pääkäyttäjät": "Company main users",
  "Näytä kuponki": "Show coupon",
  "Sulje": "Close",
  "Kirjoita viestisi": "Write your message",
  "Aloita keskustelu": "Start chatting",
  "Yksityiset keskustelut": "Private chat",
  "Ei kanavia": "No channels",
  "Ryhmäkeskustelut": "Group chats",
  "Viesti poistettu": "Message deleted",
  "Poista viesti": "Delete message",
  "Olet ilmoittautunut tapahtumaan": "You have enrolled",
  "Peru ilmoittautuminen": "Cancel enrollment",
  "Et ole ilmoittautunut tapahtumaan": "You have not enrolled",
  "Ilmoittaudu mukaan": "Enroll",
  "Jätä palaute tai kysymys": "Leave feedback or a question",
  "Kiitos, viesti lähetetty": "Thank you, message has been sent",
  "Kirjoita palaute tai kysymys": "Write feedback or question",
  "Haluan henkilökohtaisen vastauksen": "I want a personal answer",
  "Anna sähköposti tai puhelinnumero": "You email or phone number",
  "Anna sähköpostiosoite tai puhelinnumero": "Enter email or phone number",
  "Tervetuloa Piiriin": "Welcome to Piiri",
  "Käyttäjätunnus tai puhelinnumero": "Username or phone number",
  "Jatka": "Continue",
  "Salasana": "Password",
  "Kirjaudu sisään": "Login",
  "Pin koodi": "Pin code",
  "Pin koodin saapumisessa voi kestää hetken.": "It may take a while for the pin code to arrive.",
  "Kirjautuminen epäonnistui": "Login failed",
  "Kirjautuminen epäonnistui, tarkista pin koodi": "Login failed, check pin code",
  "Kirjaudutaan ulos...": "Logging out...",
  "Uusimmat": "Latest",
  "Meillä töissä": "Employees",
  "Piiri-artikkelit": "Piiri-articles",
  "Omat tiedot & asetukset": "My information and settings",
  "Tietoa Piiri-sovelluksesta": "About the Piiri app",
  "Mikä on Piiri Kit?": "What is Piiri Kit?",
  "Tietosuojaseloste": "Privay policy",
  "Töissä": "At work",
  "Poissa töistä": "Absent from work",
  "Anna avainsana kaikilla kielillä.": "Enter keyword in all languages.",
  "Avainsana": "Keyword",
  "Haluatko varmasti poistaa avainsanan?": "Are you sure you want to delete the keyword?",
  "Muokkaa avainsanaa": "Edit keyword",
  "Luo uusi avainsana": "Create new keyword",
  "Avainsanat": "Keywords",
  "Hae avainsanoja tai lisää uusi": "Search keywords or add new",
  "Paina Enter luodaksesi uuden avainsanan": "Press Enter to create new keyword",
  "Avainsanojen hallinta": "Keyword management",
  "Uudistamme kyselyjä. Pääset kokeilemaan uutta kyselytyökalua": "We are renewing surveys. You can try the new survey tool",
  "tästä": "here",
  "Kyselyn vastaukset": "Survey answers",
  "Viimeisin vastaus": "Latest answer",
  "Näytetään": "Showing",
  "Kyselyä ei löytynyt": "Survey not found",
  "Saat PIN-koodin tekstiviestillä mikäli puhelinnumerosi on järjestelmässämme. Syötä se alle.": "You will receive a PIN code via text message if your phone number is in our system. Enter it below.",
  "Jos et saanut PIN-koodia, tarkista että syötit puhelinnumerosi oikein.": "If you didn't receive a PIN code, please check that you entered your phone number correctly.",
  "Kirjoita hakusana": "Enter a search term",
  "Hakusanan tulee olla vähintään 3 merkkiä pitkä": "The search term must be at least 3 characters long"
}
